import type { ScopeKeysType } from '../../companyData/EmissionsYear';
import type { AssetYearFieldsTemp } from '../types/FinanceFragments';

export const SCOPE_TO_OVERRIDE_FIELD_MAP = new Map([
  ['scope1', 'scope1OverrideTco2e'],
  ['scope2Location', 'scope2LocationOverrideTco2e'],
  ['scope2Market', 'scope2MarketOverrideTco2e'],
  ['scope3', 'scope3OverrideTco2e'],
  ['scope301', 'scope301OverrideTco2e'],
  ['scope302', 'scope302OverrideTco2e'],
  ['scope303', 'scope303OverrideTco2e'],
  ['scope304', 'scope304OverrideTco2e'],
  ['scope305', 'scope305OverrideTco2e'],
  ['scope306', 'scope306OverrideTco2e'],
  ['scope307', 'scope307OverrideTco2e'],
  ['scope308', 'scope308OverrideTco2e'],
  ['scope309', 'scope309OverrideTco2e'],
  ['scope310', 'scope310OverrideTco2e'],
  ['scope311', 'scope311OverrideTco2e'],
  ['scope312', 'scope312OverrideTco2e'],
  ['scope313', 'scope313OverrideTco2e'],
  ['scope314', 'scope314OverrideTco2e'],
  ['scope315', 'scope315OverrideTco2e'],
  ['scope316', null],
  ['scope317', null],
]) satisfies Map<keyof ScopeKeysType, keyof AssetYearFieldsTemp | null>;
